export default {

    bind (el, bindings, vnode) {
        const me = vnode.data.directives.find(item => item.name === 'ratio').def;
        window.addEventListener("resize", () => me.calcHeight(el, bindings.value));
        setTimeout(() => {
            me.calcHeight(el, bindings.value);
        });
    },

    calcHeight(el, ratio) {
        setTimeout(() => {
            el.style.height = el.clientWidth / ratio + 'px';
        }, 250);
    },

    unbind(el, bindings, vnode) {
        const me = vnode.data.directives.find(item => item.name === 'ratio').def;
        window.removeEventListener("resize", () => me.calcHeight(el, bindings.value));
    }

}
